const pluralRules = new Intl.PluralRules('ru-RU')

// Русское склонение по количеству: pluralRu(5, 'участник', 'участника', 'участников').
export function pluralRu(count: number, one: string, few: string, many: string): string {
  switch (pluralRules.select(count)) {
    case 'one':
      return one
    case 'few':
      return few
    default:
      return many
  }
}
